<template>
	<div>
		<div id="imchatWin"></div>
		<van-overlay class="page-mask" :show="circleVisible">
			<div class="bullet-box-wrap1" style="top: 30%;">
				<div class="bullet-box-content1" style="height: auto;">
					<div class="font-15 m-b-20">正在处理...</div>
					<van-circle v-model="currentRate" :stroke-width="50" :rate="rate" :speed="80" :text="rate+'%'" color="#1F85FC"
						layer-color="none">
					</van-circle>
				</div>
			</div>
		</van-overlay>
	</div>
</template>
<script>
	import TIM from 'tim-js-sdk'
	import TIMUploadPlugin from 'tim-upload-plugin'
	import {
		mapMutations
	} from 'vuex'
	export default {
		name: 'imchatWin',
		props: ['activeDate'],
		data: function() {
			return {
				statusType: 'ONLINE',
				noReplyEvent: null,
				rate: 0,
				circleVisible: false,
				currentRate: 0,
				isSending: false,
				hisIsOver: false,
				userId: localStorage.getItem('userId1'),
				myImId: null,
				IM: null, // im实例
				linkState: false, // 登陆状态
				isImOk: false, // sdk是否准备好
				chatlist: [],
				selToID: '', //	发送对象的id
				lastShowChatTime: 0, //  最后显示聊天的时间
				isSend: false, // 是否正在发送
				MsgParams: {
					pageNo: 1,
					pageSize: 20
				},
				dialogId: null,
				dialagNum: 0,
				dialogShow: false,
				langIsEn: localStorage.getItem('lang'),
				selType: 'C2C', // session模式 这里只用单聊
				serviceType: localStorage.getItem('serviceType') || 'pre-sale'
			}
		},
		computed: {

		},
		created() {},
		beforeDestroy() {
			if (this.linkState || this.isImOk) this.logoutIm()
		},
		mounted() {
			if (!this.userId) {
				let num = Math.floor(Math.random() * 900) + 10000;
				let userId = new Date().getTime().toString();
				userId = userId + num
				this.userId = Number(userId)
				localStorage.setItem('userId1', this.userId)
			}
			this.getServiceImAccount()
			let _this = this
			window.onbeforeunload = function() {
				if (_this.linkState) _this.logoutIm()
			}
		},
		methods: {
			getServiceImAccount() {
				let IMconsults_ = JSON.parse(localStorage.getItem('IMconsults')) || [];
				if (IMconsults_.length == 0) {
					this.request
						.get(
							`${this.WITSBOX_ENV_PARAM.baseUrl}/portal/consults`
						)
						.then((res) => {
							let dataModel = res.dataModel;
							let IMconsults = [{
									serviceType: dataModel[0].serviceType,
									serviceImAccount: dataModel[0].serviceImAccount,
									dialogId: null,
									isContact: false
								},
								{
									serviceType: dataModel[1].serviceType,
									serviceImAccount: dataModel[1].serviceImAccount,
									dialogId: null,
									isContact: false
								}
							]
							for (let u = 0; u < IMconsults.length; u++) {
								if (this.serviceType == IMconsults[u].serviceType) {
									IMconsults[u].isContact = true
								}
							}
							localStorage.setItem('IMconsults', JSON.stringify(IMconsults))
							if (!this.linkState || !this.isImOk) {
								this.initIM()
							}
						})
				} else {
					IMconsults_[0].isContact = false
					IMconsults_[1].isContact = false;
					for (let u1 = 0; u1 < IMconsults_.length; u1++) {
						if (this.serviceType == IMconsults_[u1].serviceType) {
							IMconsults_[u1].isContact = true
						}
					}
					localStorage.setItem('IMconsults', JSON.stringify(IMconsults_))
					if (!this.linkState || !this.isImOk) {
						this.initIM()
					}
				}
			},
			preloader(img) {
				var imageObj = new Image();
				imageObj.src = img
			},
			initIM() {
				if (!this.userId) {
					return false
				}
				let name = this.userId.toString().slice(-5)
				this.myImId = `${this.userId}`
				this.request
					.post(`${this.WITSBOX_ENV_PARAM.baseUrl}/im/createIm`, {
						Nick: "访客" + name,
						Identifier: this.userId
					})
					.then((res) => {

					})
				this.request
					.post(`${this.WITSBOX_ENV_PARAM.baseUrl}/im/authInfo`, {
						userId: this.myImId
					})
					.then((res) => {
						if (res.success) {
							if (res.dataModel && !!res.dataModel.signature) {
								let options = {
									SDKAppID: res.dataModel.appId
								}
								this.IM = TIM.create(options)
								this.IM.registerPlugin({
									'tim-upload-plugin': TIMUploadPlugin
								})
								this.IM.setLogLevel(1)
								this.initEvent()
								this.loginIm({
									UserSig: res.dataModel.signature
								})
							}
						} else {
							this.Toast(res.message)
						}
					})
			},
			// IM监听事件
			initEvent() {
				let this_ = this
				let tim = this.IM
				tim.on(TIM.EVENT.SDK_READY, this.ImEvent_SDK_READY)
				tim.on(TIM.EVENT.MESSAGE_RECEIVED, this.ImEvent_MESSAGE_RECEIVED)
				tim.on(TIM.EVENT.CONVERSATION_LIST_UPDATED, function(event) {
					console.log('收到会话列表更新通知', event.data)
					let conversationList_ = event.data;
					let newSys = conversationList_.find((i) => {
						return i.conversationID == 'C2Cdeadmin' && i.unreadCount > 0
					})
					if (newSys) {
						console.log('newSys=>', newSys)
						this.getCustomMessage(newSys.lastMessage)
					}
					this_.setUnreadListRead(conversationList_)
					let conversationList = []
					conversationList_.forEach((item) => {
						let payload = item.lastMessage.payload;
						var content = {};
						let type;
						if (item.lastMessage.type == 'TIMVideoFileElem') {
							type = 'video'
							content.remoteVideoUrl = payload.remoteVideoUrl
							content.thumbUrl = payload.thumbUrl
						} else if (item.lastMessage.type == 'TIMImageElem') {
							type = 'image'
							content.imageUrl = payload.imageInfoArray[0].imageUrl
						} else if (item.lastMessage.type == 'TIMTextElem') {
							if (payload.text.indexOf('CommunicateDialogMsg/') != -1) {
								type = 'audio'
							} else {
								type = 'text'
							}
							content = payload
						} else if (item.lastMessage.type == 'TIMCustomElem') {
							type = 'communicate'
							content = payload
						}
						let obj = {
							SessionType: item.type,
							SessionId: item.userProfile.userID,
							SessionNick: item.userProfile.nick,
							SessionImage: item.userProfile.avatar,
							UnreadMsgCount: item.unreadCount,
							MsgTimeStamp: item.lastMessage.lastTime + '000',
							MsgShow: content,
							msgType: type
						}
						conversationList.push(obj)
					})

					this_.$root.Bus.$emit('dialistUpdata', conversationList)
				})
				tim.on(TIM.EVENT.SDK_NOT_READY, this.ImEvent_SDK_NOT_READY)
				tim.on(TIM.EVENT.KICKED_OUT, this.ImEvent_KICKED_OUT)
				tim.on(TIM.EVENT.MESSAGE_READ_BY_PEER, this.MESSAGE_READ_BY_PEER)
			},
			//  登陆im
			loginIm(data) {
				let tim = this.IM
				let promise = tim.login({
					userID: this.myImId,
					userSig: data.UserSig
				})
				promise
					.then((imResponse) => {
						console.log('登录成功', imResponse.data) // 登录成功
						this.linkState = true
					})
					.catch((imError) => {
						console.warn('登录失败', imError) // 登录失败的相关信息
					})
			},

			ImEvent_SDK_READY(event) {
				console.log('tim完毕', event)
				this.isImOk = true
			},
			async ImEvent_MESSAGE_RECEIVED(event) {
				let IMconsults = JSON.parse(localStorage.getItem('IMconsults'));

				let msg = event.data[0]
				console.log('新消息=》', msg)
				if (msg.from == 'deadmin') {
					this.getCustomMessage(msg)
					return false
				}
				$('.Hint').hide();
				let hishoryServiceType = JSON.parse(JSON.stringify(this.serviceType))

				let time = msg.time + '000';
				let payload = msg.payload;
				var content = {};
				let type;
				if (msg.type == 'TIMVideoFileElem') {
					type = 'video';
					content.remoteVideoUrl = payload.remoteVideoUrl
					content.thumbUrl = payload.thumbUrl
				} else if (msg.type == 'TIMImageElem') {
					type = 'image'
					content.imageUrl = payload.imageInfoArray[0].imageUrl
				} else if (msg.type == 'TIMTextElem') {
					if (payload.text.indexOf('CommunicateDialogMsg/') != -1) {
						type = 'audio'
					} else {
						type = 'text'
					}
					content = payload
				} else if (msg.type == 'TIMCustomElem') {
					if (payload.description == 'text') {
						type = 'text';
						content = payload
					} else if (payload.description == 'audio') {
						type = 'text';
						content = payload
					} else if (payload.description == 'image') {
						type = 'text';
						content = payload
					} else if (payload.description == 'video') {
						type = 'text';
						content = payload
					} else if (payload.description == 'communicateCitations') {
						type = 'text';
						content = payload
					} else if (payload.description == 'technology') {
						let i =IMconsults.findIndex(item=>item.serviceType == 'post-sale')
						if(i>=0){
							IMconsults.forEach(item=>{
								item.isContact = false
							})
							IMconsults[i].isContact = true
						}
						localStorage.setItem('IMconsults', JSON.stringify(IMconsults))
						type = 'text';
						content = payload;
						localStorage.setItem('serviceType', 'post-sale');
						this.serviceType = localStorage.getItem('serviceType') || 'pre-sale';
						this.Toast('即将为你跳转到技术老师页面');
						let cstz = JSON.parse(payload.data);
						let MergerMsgjs = cstz.MergerMsg
						console.log('转技术页面+++。', cstz, cstz.MergerMsg)
						setTimeout(() => {
							// window.location.replace(`/middle?teacherId=${MergerMsgjs.teacherId}&teacherName=${encodeURI(MergerMsgjs.teacherName)}&serviceId=${MergerMsgjs.serviceId}&dialogId=${MergerMsgjs.dialogId}`)
							this.$router.push({
								path: '/middle',
								query: {
									teacherId: MergerMsgjs.teacherId,
									teacherName: encodeURI(MergerMsgjs.teacherName),
									serviceId: MergerMsgjs.serviceId,
									dialogId: MergerMsgjs.dialogId,
								}
							})
						}, 3000)
					} else if (payload.description == 'endConversation') {
						let i =IMconsults.findIndex(item=>item.serviceType == 'pre-sale')
						if(i>=0){
							IMconsults.forEach(item=>{
								item.isContact = false
							})
							IMconsults[i].isContact = true
						}
						localStorage.setItem('IMconsults', JSON.stringify(IMconsults))
						type = 'text';
						content = payload;
						localStorage.setItem('serviceType', 'pre-sale');
						this.serviceType = localStorage.getItem('serviceType') || 'pre-sale';
						this.Toast('即将为你跳转到课程咨询老师页面');
						let cstz = JSON.parse(payload.data);
						let MergerMsgjs = cstz.MergerMsg
						console.log('转客服页面+++。', cstz, cstz.MergerMsg)
						setTimeout(() => {
							// window.location.replace(`/middle?teacherId=${MergerMsgjs.teacherId}&teacherName=${encodeURI(MergerMsgjs.teacherName)}&serviceId=${MergerMsgjs.serviceId}&dialogId=${MergerMsgjs.dialogId}`)
							this.$router.push({
								path: '/middle',
								query: {
									teacherId: MergerMsgjs.teacherId,
									teacherName: encodeURI(MergerMsgjs.teacherName),
									serviceId: MergerMsgjs.serviceId,
									dialogId: MergerMsgjs.dialogId,
								}
							})
						}, 3000)
					} else {
						type = 'communicate'
						content = payload
					}
				}
				if (msg.from == this.selToID) {

					let chart = {
						name: this.getImNickName(msg.nick),
						isMe: msg.flow == 'out',
						id: msg.ID,
						time: Number(time),
						type: type,
						con: content,
						userType: hishoryServiceType
					}
					let chatlist_ = JSON.parse(localStorage.getItem('chatlist')) || [];
					if (msg.type == 'TIMCustomElem') {
						let con = JSON.parse(chart.con.data)
						for (let u = 0; u < this.chatlist.length; u++) {
							if (con.MergerMsg.dialogId == this.chatlist[u].id) {
								this.chatlist.splice(u, 1)
							}
						}
						for (let u1 = 0; u1 < chatlist_.length; u1++) {
							if (con.MergerMsg.dialogId == chatlist_[u1].id) {
								chatlist_.splice(u1, 1)
							}
						}
					}
					for (let i = 0; i < this.chatlist.length; i++) {
						this.$set(this.chatlist[i], 'isRead', true);
					}
					for (let i1 = 0; i1 < chatlist_.length; i1++) {
						chatlist_[i1].isReaded = true
					}
					this.showMes(chart, false)
					this.setRead('C2C' + this.selToID);
				} else {
					if (this.$parent.$children[this.$parent.$children.length - 1].sessionList) {
						let index = this.$parent.$children[this.$parent.$children.length - 1].sessionList.findIndex(item => {
							return msg.from == item.SessionId
						});
						if (index != -1) {

						} else {
							let parent = {
								MsgShow: msg.payload,
								MsgTimeStamp: time,
								SessionId: msg.from,
								SessionImage: msg.avatar,
								SessionNick: this.getImNickName(msg.nick),
								type: type,
								UnreadMsgCount: 1,
								msgType: content,
								conversationID: `C2C${msg.from}`
							}

							this.$parent.$children[this.$parent.$children.length - 1].dialagNum = this.$parent
								.$children[this.$parent.$children.length - 1].dialagNum + 1
							this.$parent.$children[this.$parent.$children.length - 1].sessionList.unshift(parent)
						}
					}
				}
			},
			ImEvent_SDK_NOT_READY(event) {
				console.log('TIM工作失败', event)
				this.isImOk = false
			},
			MESSAGE_READ_BY_PEER(event) {
				if (event.data[0].to === this.selToID) {
					for (let i = 0; i < this.chatlist.length; i++) {
						this.$set(this.chatlist[i], 'isRead', true);
					}
				}
				this.$forceUpdate()
			},
			ImEvent_KICKED_OUT(event) {
				this.Toast(this.$t('communicate.ltsx'))
				console.error('收到被踢下线通知', event.data.type)
				this.isImOk = false
				this.linkState = false

				try {} catch (e) {}
				if (
					event.data.type == TIM.TYPES.KICKED_OUT_MULT_ACCOUNT ||
					event.data.type == TIM.TYPES.KICKED_OUT_MULT_DEVICE
				) {
					console.log('你的账号可能在别处使用，请重新登录')
				}
			},
			//  从ImId中获取用户昵称
			getImNickName(iname) {
				let index = iname.indexOf('@')
				let name = iname.substring(index + 1)
				return name
			},
			//  设置已读
			setRead(id) {
				this.modifyState()
				let tim = this.IM;
				if (tim) {
					tim.setMessageRead({
						conversationID: id
					})
				}
			},
			modifyState() {
				if (this.dialogId) {
					let selToID = this.selToID
					if (selToID.indexOf('test') > -1 || selToID.indexOf('prod') > -1) {
						selToID = selToID.slice(4)
					}
					this.request
						.put(
							`${this.WITSBOX_ENV_PARAM.baseUrl}/portal/dialog/${this.dialogId}/readed?userId=${selToID}`
						)
						.then((res) => {})
				}

			},
			//  退出登陆
			logoutIm() {
				if (!this.IM) return
				let tim = this.IM
				let promise = tim.logout()
				tim.off(TIM.EVENT.SDK_READY, this.ImEvent_SDK_READY)
				tim.off(TIM.EVENT.MESSAGE_RECEIVED, this.ImEvent_MESSAGE_RECEIVED)
				tim.off(TIM.EVENT.SDK_NOT_READY, this.ImEvent_SDK_NOT_READY)
				tim.off(TIM.EVENT.KICKED_OUT, this.ImEvent_KICKED_OUT)
				tim.off(TIM.EVENT.MESSAGE_READ_BY_PEER, this.MESSAGE_READ_BY_PEER)
				promise
					.then((imResponse) => {
						console.log('退出成功', imResponse.data) // 登出成功
					})
					.catch((imError) => {
						console.warn('退出失败', imError)
					})
			},
			openChatWin(item, more) {
				let time = item.time;
				if (!more) {
					this.chatlist = [];
					time = new Date().getTime()
				}
				this.dialogId = item.id
				this.selToID = item.SessionId
				this.getMsgList(item.id, time, more)
			},
			compareTimestamp(a, b) {
			  return b.time - a.time;
			},
			async getMsgList(id, time, more) {
				let IMconsults = JSON.parse(localStorage.getItem('IMconsults'));
				let cSDialogId1 = IMconsults[0].dialogId;
				let cSDialogId2 = IMconsults[1].dialogId;
				let newList = [];
				this.setRead('C2C' + this.selToID)
				let resp = await this.request.get(`${this.WITSBOX_ENV_PARAM.baseUrl}/portal/dialog/${cSDialogId1}/msgs`);
				if (resp.success) {
					let messageList1 = resp.dataModel || []
					messageList1.forEach((item) => {
						let chart1 = {
							name: item.userName,
							userImg: item.userImg,
							isMe: item.userId == this.userId,
							id: item.id,
							time: item.sendTime,
							type: item.msgType,
							con: JSON.parse(item.msg),
							isReaded: item.isReaded,
							userType: item.userType
						}
						newList.push(chart1)
					})
				}
				if (cSDialogId2) {
					let resp2 = await this.request.get(`${this.WITSBOX_ENV_PARAM.baseUrl}/portal/dialog/${cSDialogId2}/msgs`)
					if (resp2.success) {
						let messageList2 = resp2.dataModel || []
						messageList2.forEach((item) => {
							let chart2 = {
								name: item.userName,
								userImg: item.userImg,
								isMe: item.userId == this.userId,
								id: item.id,
								time: item.sendTime,
								type: item.msgType,
								con: JSON.parse(item.msg),
								isReaded: item.isReaded,
								userType: item.userType
							}
							if(chart2.con.overview&&chart2.con.overview.type=='overview'){
								
							}else{
								newList.push(chart2)
							}
							
						})
					}
				}
				newList = newList.sort(this.compareTimestamp);
				console.log('messageList===》', newList)
				this.request
					.get(
						`${this.WITSBOX_ENV_PARAM.baseUrl}/portal/consult?serviceType=${this.serviceType}`
					)
					.then((res) => {
						let dataModel = res.dataModel
						localStorage.setItem('serviceImAccount', dataModel.serviceImAccount);
						if (newList.length > 5) {
							this.hisIsOver = true
						}
						if(this.$route.query.isTransform == '1'){
							if(this.serviceType == 'pre-sale'){
								newList.unshift({
									type: 'tip1-4',
									text: '',
									time: new Date().getTime()
								})
							}else{
								newList.unshift({
									type: 'tip1-5',
									text: '',
									time: new Date().getTime()
								})
							}
							this.timeDown(10)
							this.addHisMsg(newList, more)
							return
						}
						if (this.serviceType == 'pre-sale') {
							if (dataModel.status == 'online') {
								newList.unshift({
									type: 'tip1',
									text: '',
									time: new Date().getTime()
								})
								clearTimeout(this.noReplyEvent)
								this.noReplyEvent = null;
								this.timeDown(10)
								// 1秒后显示另外一句默认文字
								setTimeout(() => {
									this.chatlist.push({
										type: 'tip1-1',
										text: '',
										time: new Date().getTime()
									})
									this.chatlist.push({
										type: 'tip1-2',
										text: '',
										showTransform:true,
										time: new Date().getTime()
									})
									this.scrollToNew();
								}, 1000);
							} else {
								newList.unshift({
									type: 'tip4',
									text: '',
									time: new Date().getTime()
								}, {
									type: 'tip3',
									text: '',
									time: new Date().getTime()
								})

							}
						} else {
							if (dataModel.status == 'offline') {
								newList.unshift({
									type: 'tip5',
									text: '',
									time: new Date().getTime()
								})
							} else {
								newList.unshift({
									type: 'tip6',
									text: '',
									time: new Date().getTime()
								})
							}
						}

						this.addHisMsg(newList, more)
					})

			},
			timeDown(n) {
				if (n <= 0) {
					clearTimeout(this.noReplyEvent);
					this.chatlist.push({
						type: 'tip2',
						text: '',
						serviceType:this.serviceType,
					})
					this.scrollToNew();
					return;
				}
				this.noReplyEvent = setTimeout(() => {
					n = n - 1;
					this.timeDown(n)
					console.log('倒计时11===》', n)
				}, 1000);
			},
			//  新增历史消息
			addHisMsg(mesList, more) {
				let isHis = false
				let list;
				if (more) {
					isHis = true
					list = mesList;
				} else {
					list = mesList.reverse()
				}

				list.forEach((mes) => {
					this.showMes(mes, isHis, more)
				})

				if (more) {
					setTimeout(() => {
						const PageId = document.querySelector('#key_' + more)
						PageId.scrollIntoView({
							behavior: 'instant',
							block: 'center',
							inline: 'start'
						})
					}, 0)
				}
			},

			//  显示一条聊天信息
			showMes(msg, isHis, id) {
				this.circleVisible = false;
				setTimeout(() => {
					this.rate = 0;
				}, 1000)

				let name = ''
				if (msg.isMe) {
					name = '我'
				} else {
					name = msg.name
				}
				let msgcon = msg.con
				let time = msg.time

				let isTeacher;
				let description;
				let videothumbUrl2;
				let type = msg.type // 获取元素类型
				switch (type) {
					case 'video':
						videothumbUrl2 =
							msgcon.thumbUrl.indexOf('https://') > -1 ?
							msgcon.thumbUrl :
							this.global.getOssFileUrl(msgcon.thumbUrl)
						msgcon =
							"<div class='message-video-box'><img src='" +
							videothumbUrl2 +
							"'  /></div>"
						break
					case 'image':
						let imgthumbUrl2 =
							msgcon.imageUrl.indexOf('https://') > -1 ?
							msgcon.imageUrl :
							this.global.getOssFileUrl(msgcon.imageUrl)
						msgcon = "<img src='" + imgthumbUrl2 + "' />"
						this.preloader(imgthumbUrl2)
						break
					case 'audio':
						msgcon = msgcon.text
						break

					case 'text':
						if (msgcon.data) {
							msgcon = JSON.parse(msgcon.data)

						} else if (msgcon.overview) {
							msgcon = msgcon.overview
							type = 'overview'
						} else {
							msgcon = msgcon.text
						}
						break
					case 'communicate':
						let data = JSON.parse(msgcon.data)
						isTeacher = data.MergerMsg.isTeacher
						break
					default:
						console.warn('未解析消息元素类型: elemType=' + type)
						break
				}

				//  是否需要显示时间
				let newMsg = {
					id: msg.id,
					time: Number(time),
					name: name,
					isMe: msg.isMe,
					con: msgcon,
					type: type,
					isShowTime: this.isShowTime(time, isHis),
					isReaded: msg.isReaded,
					isTeacher: isTeacher,
					videothumbUrl2: videothumbUrl2,
					userType: msg.userType
				}
				if (type == 'TIMVideoFileElem' || type == 'video') {
					let videoUrl1 =
						msg.con.remoteVideoUrl.indexOf('https://') > -1 ?
						msg.con.remoteVideoUrl :
						this.global.getOssFileUrl(msg.con.remoteVideoUrl)
					newMsg.videoUrl = videoUrl1
				}
				if (type == 'TIMImageElem' || type == 'image') {
					let IMAGEUrl1 =
						msg.con.imageUrl.indexOf('https://') > -1 ?
						msg.con.imageUrl :
						this.global.getOssFileUrl(msg.con.imageUrl)
					newMsg.imageUrl = IMAGEUrl1
				}

				if (isHis) {
					this.chatlist.unshift(newMsg)
				} else {
					this.chatlist.push(newMsg)
				}
				if (id) {} else {
					this.scrollToNew();
				}
			},
			//  是否显示时间
			isShowTime(time, isHis) {
				if (!isHis) {
					let isShowTime = time - this.lastShowChatTime > 300000
					if (isShowTime) this.lastShowChatTime = time
					return isShowTime
				} else {
					let isShowTime = !this.lastShowChatTime ?
						true :
						this.lastShowChatTime - time > 300000
					if (isShowTime) this.lastShowChatTime = time
					return isShowTime
				}
			},
			//  滚动条到最新
			scrollToNew() {
				setTimeout(() => {
					this.$nextTick(() => {

						if (this.$parent.$children[this.$parent.$children.length - 1]) {
							this.$parent.$children[this.$parent.$children.length - 1].scrollToNew()
						}
					})
				}, 500)
			},


			getBase64Image(img) {
				var canvas = document.createElement('canvas')
				canvas.width = img.width
				canvas.height = img.height
				var ctx = canvas.getContext('2d')
				ctx.drawImage(img, 0, 0, img.width, img.height)
				var ext = img.src.substring(img.src.lastIndexOf('.') + 1).toLowerCase()
				var dataURL = canvas.toDataURL('image/' + ext)
				return dataURL
			},
			toImg(imgUrl, fileKey) {
				var _this = this
				var image = new Image()
				image.src = imgUrl
				image.setAttribute('crossOrigin', 'Anonymous')
				image.onload = function() {
					var base64 = _this.getBase64Image(image)
					_this.base64 = base64
					// 转换base64到file
					var file = _this.btof(base64, 'test')
					console.log('file=>', file)
					_this.global
						.putOssObject(fileKey, file)
						.then((res) => {})
						.catch({})
				}
			},
			btof(data, fileName) {
				const dataArr = data.split(',')
				const byteString = atob(dataArr[1])

				const options = {
					type: 'image/jpeg',
					endings: 'native'
				}
				const u8Arr = new Uint8Array(byteString.length)
				for (let i = 0; i < byteString.length; i++) {
					u8Arr[i] = byteString.charCodeAt(i)
				}
				return new File([u8Arr], fileName + '.jpg', options)
			},

			// 单个文件的上传
			uploadSingle3(file, event1, flag, OssType, sendOK) {
				if (!this.linkState || !this.isImOk) {
					event1.target.value = ''
					this.$parent.$children[this.$parent.$children.length - 1].loading = false
					this.Toast('IM 未登录成功 请关闭 重新登录')
					return
				}
				this.rate = 5
				this.circleVisible = true
				let _arr = file && file.name && file.name.split('.')
				let type = _arr[_arr && _arr.length - 1]
				type = type.toLowerCase()
				let tim = this.IM
				let message;
				let this_ = this
				if (type == 'mp4') {
					this.$parent.$children[this.$parent.$children.length - 1].IMGtime = this.$parent.$children[this.$parent
						.$children.length - 1].IMGtime + 1
					if (this.$parent.$children[this.$parent.$children.length - 1].IMGtime == 1) {

					}
					message = tim.createVideoMessage({
						to: this.selToID,
						conversationType: TIM.TYPES.CONV_C2C,
						payload: {
							file: file
						},
						onProgress: function(event) {
							let rate = this_.$mul(event, 100);
							let rate1 = this_.$sub(rate, 10)
							if (rate1 > this_.rate) {
								this_.rate = rate1;
							}

							console.log('file Video:', rate)
						}
					})
				} else {
					message = tim.createImageMessage({
						to: this.selToID,
						conversationType: TIM.TYPES.CONV_C2C,
						payload: {
							file: file
						},
						onProgress: function(event) {
							let rate_ = this_.$mul(event, 100);
							this_.rate = 80
							console.log('file uploading:', rate_)
						}
					})
				}
				let promise = tim.sendMessage(message)
				promise
					.then((imResponse) => {
						this_.rate = 92
						if (flag) {
							this.$parent.$children[this.$parent.$children.length - 1].IMGtime = 0

							this.isSending = false
						}

						console.log('图片发送成功', imResponse);
						let msg = imResponse.data && imResponse.data.message

						let msg_ = JSON.parse(JSON.stringify(msg))
						let fileKey

						let time = msg.time + '000'
						let payload = msg.payload;
						var content = {};
						let type_;
						let OSS;
						let uuid
						if (msg.type == 'TIMVideoFileElem') {
							type_ = 'video'
							let thumbUrl = msg.payload.thumbUrl;
							let thumbUrl_url = thumbUrl.split('?')[0];
							let thumbUrl_url_ = thumbUrl_url.split('/')
							uuid = thumbUrl_url_[thumbUrl_url_.length - 1] + '.jpg'
							fileKey = `CommunicateDialogMsg/${uuid}`
							this.toImg(thumbUrl, fileKey);

							let remoteVideoUrl = msg.payload.remoteVideoUrl;

							let remoteVideoUrl_url_ = remoteVideoUrl.split('/')

							OSS = `CommunicateDialogMsg/${remoteVideoUrl_url_[remoteVideoUrl_url_.length - 1]}`
							this.global
								.putOssObject(OSS, file)
								.then((res) => {})
								.catch({})
							content.remoteVideoUrl = remoteVideoUrl
							content.thumbUrl = thumbUrl
						} else if (msg.type == 'TIMImageElem') {
							let imageUrl = msg_.payload.imageInfoArray[0].imageUrl;
							let url = imageUrl.split('?')[0];
							let url_ = url.split('/')
							uuid = url_[url_.length - 1]
							OSS = `CommunicateDialogMsg/${uuid}`
							this.toImg(imageUrl, OSS)

							type_ = 'image'
							content.imageUrl = imageUrl
						}

						let chart = {
							name: this.getImNickName(msg.nick),
							userImg: msg.avatar,
							isMe: msg.flow == 'out',
							id: msg.ID,
							time: Number(time),
							type: type_,
							con: content
						}
						this_.rate = 95
						setTimeout(() => {
							this.rate = 100;
							this.circleVisible = false

							this.getTeacherIM(chart)
						}, 1500)

						this.toBacktransfer(msg.ID, msg_.payload, msg_.type, OSS, fileKey)
						sendOK()
					})
					.catch((imError) => {
						this.isSending = false
						console.warn('sendMessage error:', imError)
					})
			},
			toAsk(text){
				let serviceType = 'pre-sale'
				if(text != '购课咨询'){
					serviceType = 'post-sale'
				}
				clearTimeout(this.noReplyEvent);
				this.chatlist.push({
					type:'tip1-3',
					text:text,
					time: new Date().getTime()
				})
				// 判断是否在线
				this.request
					.get(
						`${this.WITSBOX_ENV_PARAM.baseUrl}/portal/consult?serviceType=${serviceType}`
					)
					.then((res) => {
						if(res.success&&res.dataModel){
							let dataModel = res.dataModel
							if (dataModel.status == 'offline'){
								this.chatlist.push({
									type: 'tip1-6',
									text: '',
									serviceType:serviceType,
								})
							}else{
								// 如果当前就是目标老师
								if(this.serviceType == serviceType) {
									// this.Toast('即将为你跳转到课程咨询老师页面');
									if(serviceType == 'pre-sale'){
										this.chatlist.push({
											type: 'tip1-4',
											text: '',
											time: new Date().getTime()
										})
									}else{
										this.chatlist.push({
											type: 'tip1-5',
											text: '',
											time: new Date().getTime()
										})
									}
									this.scrollToNew();
									return
								}
								let IMconsults = JSON.parse(localStorage.getItem('IMconsults'));
								if(serviceType == 'pre-sale'){
									let i =IMconsults.findIndex(item=>item.serviceType == 'pre-sale')
									if(i>=0){
										IMconsults.forEach(item=>{
											item.isContact = false
										})
										IMconsults[i].isContact = true
									}
									this.Toast('即将为你跳转到课程咨询老师页面');
								}else{
									let i =IMconsults.findIndex(item=>item.serviceType == 'post-sale')
									if(i>=0){
										IMconsults.forEach(item=>{
											item.isContact = false
										})
										IMconsults[i].isContact = true
									}

									this.Toast('即将为你跳转到技术老师页面');
								}
								this.serviceType = serviceType
								localStorage.setItem('serviceType', serviceType);
								localStorage.setItem('IMconsults', JSON.stringify(IMconsults))
								
								this.toTransform(dataModel)
							}
							this.scrollToNew();
						}
					})
			},
			// 咨询<==>技术 转换
			toTransform(dataModel){
				setTimeout(() => {
					this.$router.push({
						path: '/middle',
						query: {
							teacherId: dataModel.serviceImAccount,
							teacherName: encodeURI(dataModel.serviceName),
							serviceId: dataModel.serviceId,
							dialogId: null,
							isTransform:'1'
						}
					})
				}, 3000)
			},
			getTeacherIM(chart) {
				this.request
					.get(
						`${this.WITSBOX_ENV_PARAM.baseUrl}/portal/consult?serviceType=${this.serviceType}`
					)
					.then((res) => {
						let dataModel = res.dataModel
						if (this.serviceType == 'pre-sale') {
							if (dataModel.status == 'offline') {
								let item = this.chatlist.find((i) => {
									return i.type == 'tip3' || i.type == 'tip1-6'
								})
								if (!item) {
									this.chatlist.push({
										type: 'tip3',
										text: ''
									}, {
										type: 'tip4',
										text: ''
									})
								}
							}
						} else {

						}

						this.showMes(chart)
					})
			},
			isTimeDifferenceGreaterThanFiveMinutes(timestamp1, timestamp2) {
				const differenceInMilliseconds = Math.abs(timestamp1 - timestamp2);
				const differenceInMinutes = differenceInMilliseconds / (1000 * 60);
				return differenceInMinutes > 5;
			},
			postImMsg() {
				console.log(111111111111111111111111111111)
				let chatlist = JSON.parse(JSON.stringify(this.chatlist));
				const filteredArray = chatlist.filter(item => item.type != 'tip1'&& item.type != 'tip1-1'&& item.type != 'tip1-2'&& item.type != 'tip1-3'&& item.type != 'tip1-4'&& item.type != 'tip1-5'&& item.type != 'tip1-6'&& item.type != 'tip2' && item.type != 'tip3' && item.type != 'tip4');
				let nowTime = new Date().getTime();

				if (filteredArray.length == 0) {
					this.postCustomerService()
				} else if (filteredArray.length > 1) {
					let item = filteredArray[filteredArray.length - 1];
					const isGreaterThanFiveMinutes = this.isTimeDifferenceGreaterThanFiveMinutes(nowTime, item.time);
					if (isGreaterThanFiveMinutes) {
						this.postCustomerService()
					}
				}

			},
			postCustomerService() {
				let obj = {
					textContent: '学生给你发消息了哦',
					touser: this.$route.query.serviceId
				}
				this.request
					.post(
						`${this.WITSBOX_ENV_PARAM.baseUrl}/sale/message`, obj
					)
					.then((res) => {})
			},

			toBacktransfer(id, content_, msgType, oss, fileKey) {
				this.postImMsg()
				clearTimeout(this.noReplyEvent);
				this.noReplyEvent = null
				let type;
				var content = {};
				if (msgType == 'TIMVideoFileElem') {
					type = 'video'
					content.remoteVideoUrl = oss
					content.thumbUrl = fileKey
				} else if (msgType == 'TIMImageElem') {
					type = 'image'
					content.imageUrl = oss
				} else {
					type = msgType
					content = content_
				}
				if (!this.dialogId) {
					return
				}
				let name = this.userId.toString().slice(-5)
				let parent = {
					dialogId: this.dialogId,
					msg: JSON.stringify(content),
					userId: this.userId,
					userName: '访客' + name,
					userRole: 2,
					msgType: type,
					id: id
				}

				this.request
					.post(
						`${this.WITSBOX_ENV_PARAM.baseUrl}/portal/dialog/${this.dialogId}/msg`,
						parent
					)
					.then((res) => {})
			},
			getConversationList() {
				let this_ = this;
				let tim = this.IM;
				let promise = tim.getConversationList();
				promise.then(function(imResponse) {
					const conversationList_ = imResponse.data.conversationList; // 会话列表，用该列表覆盖原有的会话列表
					this_.setUnreadListRead(conversationList_)
					let conversationList = []
					conversationList_.forEach((item) => {
						let payload = item.lastMessage.payload;
						var content = {};
						let type;
						if (item.lastMessage.type == 'TIMVideoFileElem') {
							type = 'video'
							content.remoteVideoUrl = payload.remoteVideoUrl
							content.thumbUrl = payload.thumbUrl
						} else if (item.lastMessage.type == 'TIMImageElem') {
							type = 'image'
							content.imageUrl = payload.imageInfoArray[0].imageUrl
						} else if (item.lastMessage.type == 'TIMTextElem') {
							if (payload.text.indexOf('CommunicateDialogMsg/') != -1) {
								type = 'audio'
							} else {
								type = 'text'
							}
							content = payload
						} else if (item.lastMessage.type == 'TIMCustomElem') {
							type = 'communicate'
							content = payload
						}
						let obj = {
							SessionType: item.type,
							SessionId: item.userProfile.userID,
							SessionNick: item.userProfile.nick,
							SessionImage: item.userProfile.avatar,
							UnreadMsgCount: item.unreadCount,
							MsgTimeStamp: item.lastMessage.lastTime + '000',
							MsgShow: content,
							msgType: type
						}
						conversationList.push(obj)
					})
					this_.$root.Bus.$emit('dialistUpdata', conversationList)
					console.log('getConversationList=>', conversationList)
				}).catch(function(imError) {
					// console.warn('getConversationList error:', imError); // 获取会话列表失败的相关信息
				});
			},
			sendCustomizingMsg(txt_, sendOK, type_) {
				if (!this.linkState || !this.isImOk) {
					this.$parent.$children[this.$parent.$children.length - 1].loading = false
					this.Toast('IM 未登录成功 请关闭 重新登录')
					return
				}
				if (!type_) {
					type_ = 'communicate'
				}
				let tim = this.IM
				let message = tim.createCustomMessage({
					to: this.selToID, //  消息的接收方
					conversationType: TIM.TYPES.CONV_C2C, //  会话类型，取值TIM.TYPES.CONV_C2C或TIM.TYPES.CONV_GROUP
					payload: {
						data: JSON.stringify(txt_), // 消息文本内容
						description: type_
					}
				})
				this.isSending = true
				let promise = tim.sendMessage(message)
				promise
					.then((imResponse) => {
						console.log('自定义消息发送成功', imResponse)
						let msg = imResponse.data && imResponse.data.message
						if (!msg) return
						let time = msg.time + '000'
						let chart = {
							name: this.getImNickName(msg.nick),
							userImg: msg.avatar,
							isMe: msg.flow == 'out',
							id: msg.ID,
							time: Number(time),
							type: type_ != 'communicate' ? 'text' : 'communicate',
							con: msg.payload
						}
						this.toBacktransfer(msg.ID, msg.payload, type_ != 'communicate' ? 'text' : 'communicate')
						console.log('chart', chart)
						this.getTeacherIM(chart)

						sendOK()
					})
					.catch((imError) => {
						this.isSending = false
						console.warn('sendMessage error:', imError)
					})
			},
			//  发送消息
			sendMsg(txt_, sendOK) {
				if (this.isSend) return
				if (this.selToID && txt_) {} else {
					return
				}
				if (!this.linkState || !this.isImOk) {
					this.$parent.$children[this.$parent.$children.length - 1].loading = false
					this.Toast('IM 未登录成功 请刷新 重新登录')
					return
				}
				console.log('sendMsg',this.selToID,this.IM);
				let tim = this.IM
				let message = tim.createTextMessage({
					to: this.selToID, //  消息的接收方
					conversationType: TIM.TYPES.CONV_C2C, //  会话类型，取值TIM.TYPES.CONV_C2C或TIM.TYPES.CONV_GROUP
					payload: {
						text: txt_
					}
				})
				this.isSending = true
				let promise = tim.sendMessage(message)
				promise
					.then((imResponse) => {

						console.log('发送成功', imResponse)
						let msg = imResponse.data && imResponse.data.message

						let payload = msg.payload;
						let type = 'text'
						if (payload.text.indexOf('CommunicateDialogMsg/') != -1) {
							type = 'audio'
						}

						if (!msg) return
						let time = msg.time + '000'
						let chart = {
							name: this.getImNickName(msg.nick),
							userImg: msg.avatar,
							isMe: msg.flow == 'out',
							id: msg.ID,
							time: Number(time),
							type: type,
							con: msg.payload
						}

						this.toBacktransfer(msg.ID, msg.payload, type)
						console.log('chart', chart);
						this.getTeacherIM(chart)


						sendOK()
					})
					.catch((imError) => {
						// 发送失败
						//  todo 发送失败处理
						this.isSending = false
						console.warn('sendMessage error:', imError)
					})
			},
			//  消息撤回
			recallMessage(messageID, sendOK) {
				if (this.isSend) return
				if (this.selToID && messageID) {} else {
					return
				}
				if (!this.linkState || !this.isImOk) {
					this.$parent.$children[this.$parent.$children.length - 1].loading = false
					this.Toast('IM 未登录成功 请刷新 重新登录')
					return
				}

				for (let m = 0; m < this.chatlist.length; m++) {
					if (this.chatlist[m].id == messageID) {
						this.chatlist.splice(m, 1)
						m--
					}
				}

				this.request
					.delete(`${this.WITSBOX_ENV_PARAM.baseUrl}/portal/dialog/${messageID}/msg`)
					.then((res) => {

					})
				sendOK()

			},
			imagesUplodReady() {
				return this.$refs.images.click()
			},

			//  设置未读列表为已读
			setUnreadListRead(arr) {
				let IMconsults = JSON.parse(localStorage.getItem('IMconsults'));
				let item = IMconsults.find((i) => {
					return i.isContact
				})
				let conversationID = 'C2C' + item.serviceImAccount;
				console.log('正在聊天===》', conversationID)
				let num = 0
				for (let i = 0; i < arr.length; i++) {
					if (arr[i].conversationID != 'C2Cdeadmin' && arr[i].conversationID == conversationID) {
						num = num + arr[i].unreadCount
					}
				}
				console.log('setUnreadListRead=>', num)
				if (num > 0) {
					this.SETIMTIPSSTATUS(num)
				} else {
					this.SETIMTIPSSTATUS(num)
				}
			},
			...mapMutations('common', ['SETIMTIPSSTATUS'])
		},
		watch: {
			hisIsOver(val) {
				console.log('hisIsOver=>', val)
				this.$root.Bus.$emit('hisIsOver', val)
			},
			chatlist(val) {
				console.log('chatList====>', val)
				this.$root.Bus.$emit('chatList', val)
			},
			activeDate: {
				handler(val, oldval) {
					if (!this.linkState || !this.isImOk) {
						this.userId = localStorage.getItem('userId1')
						// this.initIM()
					}
				},
				// 深度观察监听
				deep: true,
				immediate: true
			}
		}
	}
</script>



<style lang="scss" scoped>
	.bullet-box-wrap1 {
		width: 295px;
		position: absolute;
		top: 20%;
		left: 50%;
		transform: translateX(-50%);
		text-align: center;
	}

	.flex-center {
		justify-content: center
	}



	.bullet-box-content1 {
		background: #fff;
		padding: 20px 0 25px 0;
		border-radius: 15px;
		height: 355px;
		position: relative;
	}



	#imchatWin {
		position: fixed;
		top: 0;
		left: 0;
		right: 0;
		bottom: 0;
		z-index: 0;
		display: none;
		line-height: 1;

		&.show {
			z-index: 99999;
			display: block;

			.imchatWin {
				top: 50%;
			}
		}
	}
</style>



// WEBPACK FOOTER //
// src/components/imChatWin.vue